<template>

  <el-main>

    <el-form :model="user" status-icon :rules="rules" ref="user" label-width="100px">
      <el-form-item label="手机号码">
        <el-input v-model="user.phone_number" disabled></el-input>
      </el-form-item>
      <el-form-item label="用户名称" prop="username">
        <el-input v-model="user.username" autocomplete="off" maxlength="18" show-word-limit placeholder="请输入18个字符以内的用户名，只能包含英文字母和数字且须以字母开头"></el-input>
      </el-form-item>
      <el-form-item label="用户昵称" prop="nickname">
        <el-input v-model="user.nickname" autocomplete="off" maxlength="30" show-word-limit placeholder="请输入30个字符以内的用户昵称"></el-input>
      </el-form-item>
      <el-form-item label="用户密码" prop="password">
        <el-input type="password" v-model="user.password" autocomplete="off" minlength="6" maxlength="18" placeholder="请输入6-18位密码进行修改（仅修改用户名称或昵称时无需输入密码）"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="password_confirmation">
        <el-input type="password" v-model="user.password_confirmation" autocomplete="off" minlength="6" maxlength="18" placeholder="请输入6-18位密码进行修改（仅修改用户名称或昵称时无需输入密码）"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">保存信息</el-button>
      </el-form-item>
    </el-form>

  </el-main>

</template>

<script>
export default {
  name: 'User',
  data () {
    let Username = (rule, value, callback) => {
      if (value.length > 18) {
        callback(new Error('用户名最大长度为18个字符'))
      } else {
        callback()
      }
    }
    let Nickname = (rule, value, callback) => {
      if (value.length > 20) {
        callback(new Error('用户名最大长度为20个字符'))
      } else {
        callback()
      }
    }
    let Password = (rule, value, callback) => {
      if (value !== '' && (value.length < 6 || value.length > 18)) {
        callback(new Error('密码长度为6-18个字符'))
      } else {
        callback()
      }
    }
    let PasswordConfirmation = (rule, value, callback) => {
      if (this.user.password !== '' && value === '') {
        callback(new Error('请确认输入密码'))
      } else if (value !== this.user.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      serverUser: {},
      user: {
        id: '',
        user_key: '',
        phone_number: '',
        username: '',
        nickname: '',
        password: '',
        password_confirmation: ''
      },
      form: {},
      rules: {
        username: [
          { validator: Username, trigger: 'blur' }
        ],
        nickname: [
          { validator: Nickname, trigger: 'blur' }
        ],
        password: [
          { validator: Password, trigger: 'blur' }
        ],
        password_confirmation: [
          { validator: PasswordConfirmation, trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    document.title = '网湖 - 用户信息 - 网址导航|网站导航|网址大全|网站大全'
    this.$http.defaults.baseURL = process.env.VUE_APP_BASE_API
    this.getUser()
  },
  methods: {
    getUser () {
      if (localStorage.getItem('token') == null) {
        this.$router.push('/login')
        return
      }
      this.$http.get('user/get', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        if (response.data.code === 0) {
          this.serverUser = response.data.data
          for (let u in this.user) {
            if (this.serverUser[u] !== undefined) {
              this.user[u] = this.serverUser[u]
            }
          }
        } else if (response.data.code === 80003) {
          localStorage.removeItem('token')
          this.user = {}
        } else {
          this.$message({message: response.data.msg, type: 'error'})
        }
      })
    },
    save () {
      this.form = {}
      for (let u in this.user) {
        if (this.user[u] !== '' && this.user[u] !== this.serverUser[u]) {
          this.form[u] = this.user[u]
        }
      }
      if (Object.keys(this.form).length === 0) {
        this.$message.error('您还没有做任何更改')
        return
      }
      this.$refs.user.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post('user/update', this.form, {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        }).then((response) => {
          if (response.data.code === 0) {
            this.$message({message: '修改成功', type: 'success'})
          } else if (response.data.code === 80003) {
            localStorage.removeItem('token')
            this.user = {}
          } else {
            this.$message({message: response.data.msg, type: 'error'})
          }
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-main {
  margin-left: 10%;
  width: 78%;
  min-height: 85vh;
}

</style>



// WEBPACK FOOTER //
// src/components/User.vue